import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Link } from 'react-router-dom';

import './style.css';

const styles = {
  siteTitle: {
    display: 'flex',
    justifyContent: 'center',
    height: 70,
  },
  sideTitleImage: {
    margin: 0,
    padding: '10px',
    width: 200,
    // marginLeft: 20
  },
  sidebar: {
    width: 256,
    fontFamily: 'Rubik',
    height: '100%',
  },
  sidebarLink: {
    display: 'flex',
    alignItems: 'center',
    padding: '16px 16px',
    color: '#757575',
    textDecoration: 'none',
  },
  linkTitle: {
    marginLeft: 10,
  },
  divider: {
    margin: '8px 0',
    height: 1,
    backgroundColor: '#757575',
  },
  content: {
    // padding: '16px',
    height: 'calc(100% - 70px)',
    backgroundColor: '#2F323E',
  },
};

const linkConfig = [
  {
    path: '/audiences',
    title: 'Audiences',
    iconClassName: 'fa fa-sliders',
  },
  {
    path: '/imports',
    title: 'Imports',
    iconClassName: 'fa fa-upload',
  },
  {
    path: '/syncs',
    title: 'Syncs',
    iconClassName: 'fa fa-share',
  },

  {
    path: '/licenses',
    title: 'Licenses',
    iconClassName: 'fa fa-sitemap',
  },
  {
    path: '#',
    multi: true,
    title: 'Revenue',
    iconClassName: 'fa fa-dollar',
  },

  {
    path: '#',
    multi: true,
    title: 'Settings',
    iconClassName: 'fa fa-cogs',
  },
];

class Drawer extends Component {
  state = {
    pathname: '/',
    settingsOpen: false,
    revenueOpen: false,
  };

  componentDidMount() {
    console.log('drawer mount', window.location.pathname);
    if (
      window.location.pathname == '/settings' ||
      window.location.pathname == '/servertoserver' ||
      window.location.pathname == '/users' ||
      window.location.pathname == '/roles'
    )
      this.setState({ settingsOpen: true });
    else this.setState({ settingsOpen: false });

    if (
      window.location.pathname == '/revenue' ||
      window.location.pathname == '/revenue/report' ||
      window.location.pathname == '/revenue/buyers'
    )
      this.setState({ revenueOpen: true });
    else this.setState({ revenueOpen: false });
  }

  render() {
    const style = this.props.style
      ? { ...styles.sidebar, ...this.props.style }
      : styles.sidebar;

    const { pathname } = this.props.location;

    return (
      <div title='Menu' style={style}>
        <div style={styles.siteTitle}>
          <img
            src='/img/audiencerate-logo.png'
            style={styles.sideTitleImage}
            alt='audience rate'
          />
        </div>
        <div style={styles.content}>
          {linkConfig.map((link) => {
            console.log('pathname', pathname);
            let linkStyle =
              window.location.pathname === link.path
                ? { backgroundColor: '#2768EF', color: 'white' }
                : {};
            if (window.location.pathname === '/' && link.path === '/audiences')
              linkStyle = { backgroundColor: '#2768EF', color: 'white' };

            // submenu settings
            if (link.title == 'Settings' && link.multi) {
              return (
                <span key={'settings' + new Date().getTime()}>
                  {/*  Setting menu parent  */}
                  <Link
                    onClick={() =>
                      this.setState({ settingsOpen: !this.state.settingsOpen })
                    }
                    data-toggle='collapse'
                    data-target='#settingsCollapse'
                    className='drawer-link'
                    key='settingsparentmenu'
                    to={link.path}
                    style={{ ...styles.sidebarLink, ...linkStyle }}
                  >
                    <span className={link.parent ? 'drawer-link-submenu' : ''}>
                      <i className={link.iconClassName}></i>
                      <span style={styles.linkTitle}>{link.title}</span>
                      &#160;&#160;
                      {!this.state.settingsOpen && (
                        <i
                          className='submenu-icon-parent fa fa-angle-down'
                          aria-hidden='true'
                        ></i>
                      )}
                      {this.state.settingsOpen && (
                        <i
                          className='submenu-icon-parent fa fa-angle-up'
                          aria-hidden='true'
                        ></i>
                      )}
                    </span>
                  </Link>
                  {/*  Setting submenu items  */}
                  <div
                    className={
                      this.state.settingsOpen ? 'collapse show' : 'collapse'
                    }
                    id='settingsCollapse'
                  >
                    <Link
                      className='drawer-link'
                      key='settings'
                      to='/settings'
                      style={{
                        ...styles.sidebarLink,
                        ...(window.location.pathname === '/settings'
                          ? { backgroundColor: '#2768EF', color: 'white' }
                          : {}),
                      }}
                    >
                      <span className='drawer-link-submenu'>
                        <i className='fa fa-id-card-o'></i>
                        <span style={styles.linkTitle}>Account</span>
                      </span>
                    </Link>
                    <Link
                      className='drawer-link'
                      key='roles'
                      to='/roles'
                      style={{
                        ...styles.sidebarLink,
                        ...(window.location.pathname === '/roles'
                          ? { backgroundColor: '#2768EF', color: 'white' }
                          : {}),
                      }}
                    >
                      <span className='drawer-link-submenu'>
                        <i className='fa fa-user'></i>
                        <span style={styles.linkTitle}>Roles</span>
                      </span>
                    </Link>
                    <Link
                      className='drawer-link'
                      key='users'
                      to='/users'
                      style={{
                        ...styles.sidebarLink,
                        ...(window.location.pathname === '/users'
                          ? { backgroundColor: '#2768EF', color: 'white' }
                          : {}),
                      }}
                    >
                      <span className='drawer-link-submenu'>
                        <i className='fa fa-users'></i>
                        <span style={styles.linkTitle}>Users</span>
                      </span>
                    </Link>
                    <Link
                      className='drawer-link'
                      key='servertoserver'
                      to='/servertoserver'
                      style={{
                        ...styles.sidebarLink,
                        ...(window.location.pathname === '/servertoserver'
                          ? { backgroundColor: '#2768EF', color: 'white' }
                          : {}),
                      }}
                    >
                      <span className='drawer-link-submenu'>
                        <i className='fa fa-server'></i>
                        <span style={styles.linkTitle}>S2S Integration</span>
                      </span>
                    </Link>
                  </div>
                </span>
              );
            } else if (link.title == 'Revenue' && link.multi) {
              return (
                <span key={'revenue' + new Date().getTime()}>
                  {/*  revenue menu parent  */}
                  <Link
                    onClick={() =>
                      this.setState({ revenueOpen: !this.state.revenueOpen })
                    }
                    data-toggle='collapse'
                    data-target='#revenueCollapse'
                    className='drawer-link'
                    key='revenueparentmenu'
                    to={link.path}
                    style={{ ...styles.sidebarLink, ...linkStyle }}
                  >
                    <span className={link.parent ? 'drawer-link-submenu' : ''}>
                      <i className={link.iconClassName}></i>
                      <span style={styles.linkTitle}>{link.title}</span>
                      &#160;&#160;
                      {!this.state.revenueOpen && (
                        <i
                          style={{ left: '116px' }}
                          className='submenu-icon-parent fa fa-angle-down'
                          aria-hidden='true'
                        ></i>
                      )}
                      {this.state.revenueOpen && (
                        <i
                          style={{ left: '116px' }}
                          className='submenu-icon-parent fa fa-angle-up'
                          aria-hidden='true'
                        ></i>
                      )}
                    </span>
                  </Link>
                  <div
                    className={
                      this.state.revenueOpen ? 'collapse show' : 'collapse'
                    }
                    id='revenueCollapse'
                  >
                    <Link
                      className='drawer-link'
                      key='revenue'
                      to='/revenue'
                      style={{
                        ...styles.sidebarLink,
                        ...(window.location.pathname === '/revenue'
                          ? { backgroundColor: '#2768EF', color: 'white' }
                          : {}),
                      }}
                    >
                      <span className='drawer-link-submenu'>
                        <i className='fa fa-id-card-o'></i>
                        <span style={styles.linkTitle}>Revenue Report</span>
                      </span>
                    </Link>
                    <Link
                      className='drawer-link'
                      key='revenue/buyers'
                      to='/revenue/buyers'
                      style={{
                        ...styles.sidebarLink,
                        ...(window.location.pathname === '/revenue/buyers'
                          ? { backgroundColor: '#2768EF', color: 'white' }
                          : {}),
                      }}
                    >
                      <span className='drawer-link-submenu'>
                        <i className='fa fa-user'></i>
                        <span style={styles.linkTitle}>Marketplace Buyers</span>
                      </span>
                    </Link>
                  </div>
                </span>
              );
            } else if (!link.multi) {
              // normal links
              return (
                <Link
                  className='drawer-link'
                  key={link.path}
                  to={link.path}
                  style={{ ...styles.sidebarLink, ...linkStyle }}
                >
                  <span className={link.parent ? 'drawer-link-submenu' : ''}>
                    <i className={link.iconClassName}></i>
                    <span style={styles.linkTitle}>{link.title}</span>
                  </span>
                </Link>
              );
            }
          })}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Drawer)
);
